<template></template>

<script>
/*
    props
    -----

    attributeId - the id of the attribute
    versionId - the id of the currently selected version. (only needed for add-new-value change types)
    optionId - the id of the option
    changeType - 'value' | 'sort' | 'add-new-value'

    methods
    -------

    handleNewValue(newValue:String)
    handleNewValueWithSync(newValue:String)

    events
    ------

    in-progress: a call has been made
    success: the call is complete. success
    error: the call is complete. with error
    new-value-created: the create new option call is complete
*/

import axios from 'axios';

let base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'attributes-option-api-handler',
    props: {
        attributeId: String,
        versionId: String,
        changeType: String,
        optionId: String,
    },
    data() {
        return {};
    },
    methods: {
        handleNewValue(newValue) {
            this.saveNewValue(newValue, false);
        },
        handleNewValueWithSync(newValue) {
            this.saveNewValue(newValue, true);
        },
        saveNewValue(newValue, withSync) {
            if (this.changeType == 'value') {
                this.$emit('in-progress');
                axios.put(base_url + '/userinterface/attributes/option/' + this.optionId + '/value', {
                    "sync": withSync,
                    "value": newValue
                })
                .then((response) => {
                    this.$emit('success', response);
                })
                .catch((error) => {
                    if (error.response) {
                        this.$emit('error', error.response.data);
                    } else {
                        this.$emit('error', error);
                    }
                });
            } else if (this.changeType == 'sort') {
                this.$emit('in-progress');
                axios.put(base_url + '/userinterface/attributes/option/' + this.optionId + '/sort', {
                    "sync": withSync,
                    "sort_order": newValue
                })
                .then((response) => {
                    this.$emit('success', response);
                })
                .catch((error) => {
                    if (error.response) {
                        this.$emit('error', error.response.data);
                    } else {
                        this.$emit('error', error);
                    }
                });

            } else if (this.changeType == 'add-new-value') {
                this.$emit('in-progress');
                /*
                    route:
                    attributes/{id}/option

                    required data:
                    $versionId = $request->get('version_id');
                    $optionValue = $request->get('value');
                    $sortOrder = $request->get('sort_order');
                    $masterOptionId = $request->get('master_option_id');
                */
               let master_option_id = this.optionId;
               if (this.versionId == '0') {
                   master_option_id = null;
               }
                axios.post(base_url + '/userinterface/attributes/' + this.attributeId + '/option', {
                    "sync": withSync,
                    "version_id": this.versionId,
                    "value": newValue,
                    "sort_order": null,
                    "master_option_id": master_option_id,
                })
                .then((response) => {
                    this.$emit('success', response);
                    this.$emit('new-value-created');
                })
                .catch((error, payload) => {
                    if (error.response) {
                        this.$emit('error', error.response.data);
                    } else {
                        this.$emit('error', error);
                    }
                });

            }
        }
    }
}
</script>
